module.exports = __webpack_public_path__ + "img/Breezer Bucket.72d1f4ae.jpg";